{
  "$schema": "http://json-schema.org/draft-07/schema",
  "type": "object",
  "title": "Share Issuance",
  "description": "Variables needed for share certificates or notice of uncertificated shares.",
  "properties": {
    "authorized_signatory": {
      "$ref": "#/definitions/authorized_signatory"
    },
    "share_class": { "$ref": "#/definitions/share_class" },
    "share_issuance": {
      "$ref": "#/definitions/share_issuance"
    },
    "company": { "$ref": "#/definitions/company" }
  },
  "additionalProperties": false
}
